import getPublicRuntimeVariable from '@/utils/functions/getPublicRuntimeVariable'
import getEnv from '@/utils/runtime/env'

export default () =>
  getPublicRuntimeVariable('clientId', [
    `LUSTUCRU_GNOCCHI_${getEnv().toUpperCase()}_CLIENT_ID`,
    'CLIENT_ID',
  ])
